<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" v-if="selectedResources">{{ _('Edit selected') }}</h4>
      <h4 class="modal-title" v-else>{{ _('Create new...') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row" v-if="!selectedResources">
        <div class="col-xs-12 template-container">
          <label for="newResourceType">{{ _('Type') }}</label>
          <div :class="'form-group resource-wrap template-wrap' + (this.selectedType ? ' single-template' : '')">
            <template v-if="showResources">
              <button v-if="context != 'product-buyable'" type="button" :class="btnClass('resource')" v-on:click="selectType('resource')">
                <span class="fa-stack fa-sm">
                  <i class="fa fa-fw fa-cube fa-stack-1x" style="text-align: left;"></i>
                  <i class="fa fa-fw fa-clock fa-stack-1x" style="position: relative; font-size: 0.6rem; bottom: -0.2rem; text-align: center; right: -0.2rem"></i>
                </span> <span>{{ _('Reservable resource') }}</span>
              </button>
              <button v-if="context != 'product-reservable' && !btnClass('buyable').includes('hidden')" type="button" :class="btnClass('buyable')" v-on:click="selectType('buyable')"><i class="fa fa-fw fa-sm fa-cubes"></i> <span>{{ _('Stock resource') }}</span></button>
              <button v-if="!btnClass('openinghours').includes('hidden')" type="button" :class="btnClass('openinghours')" v-on:click="selectType('openinghours')"><i class="fa fa-fw fa-sm fa-clock-o"></i> <span>{{ _('Opening hours') }}</span></button>
            </template>
            <button v-if="showResourcepool && !btnClass('resourcepool').includes('hidden')" type="button" :class="btnClass('resourcepool')" v-on:click="selectType('resourcepool')"><i class="fa fa-fw fa-sm fa-sitemap"></i> <span>{{ _('Resource pool') }}</span></button>
          </div>
        </div>
      </div>
      <div class="row">
        <div :class="'col-xs-' + (isFeatureEnabled('packaging') ? '8' : '12') + ' template-container'">
          <div :class="'form-group ' + fieldClass('name')" v-on:click.stop="enableField('name')">
            <label for="newResourceName">{{ _('Name') }}</label>
            <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('name') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('name')"></i>            
            <input :disabled="!!fieldClass('name')" class="form-control" type="text" id="newResourceName" ref="name" v-model="resource.name" :placeholder="newResourcePlaceholder" />
          </div>
        </div>
        <div class="col-xs-4 template-container" v-if="selectedType !== 'openinghours' && isFeatureEnabled('packaging')">
          <div class="form-group">
            <label for="createCount">{{ _('Count') }}</label>
            <input type="number" min="1" class="form-control" id="createCount" :placeholder="_('How many items to create')" v-model="count" :disabled="selectedResources" />
          </div>
        </div>
      </div>
      <div class="row" v-if="count > 1 && isFeatureEnabled('packaging')">
        <div class="col-xs-12 template-container">
          <div class="panel-group flex-panel" id="multiAccordion" role="tablist" aria-multiselectable="false">
            <div class="panel panel-default">
              <div class="panel-heading" role="tab" id="headingMulti">
                <h4 class="panel-title">
                  <a role="button" data-toggle="collapse" data-parent="#multiAccordion" href="#collapseMulti" aria-expanded="false" aria-controls="collapseMulti">
                    <span class="title-text">{{ _('Naming of items...') }}</span>
                    <span class="indicator"></span>
                  </a>
                </h4>
              </div>
              <div id="collapseMulti" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingMulti">
                <div class="panel-body">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="naming">{{ _('Naming') }}</label>
                        <select class="form-control" v-model="naming">
                          <option value="none">{{ _('Do not change') }}</option>
                          <option value="addnum">{{ _('Add a sequential number to the end') }}</option>
                          <option value="addchar">{{ _('Add a sequential letter to the end') }}</option>
                          <option value="replacenum">{{ _('Replace a placeholder with a sequential number') }}</option>
                          <option value="replacechar">{{ _('Replace a placeholder with a sequential letter') }}</option>
                          <option value="list">{{ _('Provide a list of names') }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-6" v-if="naming !== 'none'">
                      <div class="form-group" v-if="naming !== 'list'">
                        <label for="start">{{ _('Start at') }}</label>
                        <input class="form-control" type="text" id="start" v-model="namingStart" />
                      </div>
                      <div class="form-group" v-if="naming === 'list'">
                        <label for="nameList">{{ _('List of names') }}</label>
                        <textarea class="form-control" id="nameList" v-model="nameList" wrap="virtual" rows="8" :placeholder="_('Enter one name per line')"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel-heading" role="tab" id="headingAttrs" v-if="selectedType && selectedType !== 'resourcepool'">
                <h4 class="panel-title">
                  <a class="collapsed" role="button" data-toggle="collapse" data-parent="#multiAccordion" href="javascript:;" :aria-expanded="isPanelOpen('attrs')" aria-controls="collapseAttrs" v-on:click="togglePanel('attrs')">
                    <span class="title-text">{{ _('Set resource attributes...') }}</span>
                    <span class="indicator"></span>
                  </a>
                </h4>
              </div>
              <transition v-on="slideTransition">
                <div id="collapseAttrs" class="panel-collapse" role="tabpanel" aria-labelledby="headingAttrs" v-if="isPanelOpen('attrs') && selectedType !== 'resourcepool' && selectedType !== 'buyable' && selectedType !== 'openinghours'">
                  <div :class="'panel-body' + (isEditMode ? ' editable' : '')">
                    <div class="row">
                      <div class="col-sm-6 leftcol">
                        <div :class="'form-group ' + fieldClass('mincount')" v-on:click.stop="enableField('mincount')">
                          <label for="minCount">{{ _('Minimum capacity of the resource') }}</label>
                          <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('mincount') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('mincount')"></i>
                          <input :disabled="!!fieldClass('mincount')" type="number" data-android-inputmode="decimal" class="form-control" ref="mincount" id="minCount" v-model="resource.mincount" />
                        </div>
                        <div :class="'form-group ' + fieldClass('count')" v-on:click.stop="enableField('count')">
                          <label for="count">{{ _('Maximum capacity of the resource') }}</label>
                          <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('count') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('count')"></i>
                          <input :disabled="!!fieldClass('count')" type="number" data-android-inputmode="decimal" class="form-control" ref="count" id="count" v-model="resource.count" />
                        </div>
                        <div :class="'form-group ' + fieldClass('extracount')" v-on:click.stop="enableField('extracount')">
                          <label for="extraCount">{{ _('Extra capacity of the resource') }}</label>
                          <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('extracount') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('extracount')"></i>
                          <input :disabled="!!fieldClass('extracount')" class="form-control" ref="extracount" id="extraCount" type="number" data-android-inputmode="decimal" v-model="resource.extracount" />
                        </div>
                        <div :class="'checkbox ' + fieldClass('enable_shared_reservation')" v-on:click.stop="enableField('enable_shared_reservation')">
                          <label>
                            <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('enable_shared_reservation') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('enable_shared_reservation')"></i>
                            <input :disabled="!!fieldClass('enable_shared_reservation') || resource.quantity > 1" type="checkbox" name="enable_shared_reservation" v-model="resource.enable_shared_reservation" true-value="1" false-value="0" />
                            <span>{{ _('Allow separate reservations at the same time') }}</span>
                          </label>
                        </div>
                        <div v-if="isEditMode || parseInt(resource.enable_shared_reservation) === 1" :class="'checkbox ' + fieldClass('shared_reservation_scope')" v-on:click.stop="enableField('shared_reservation_scope')">
                          <label>
                            <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('shared_reservation_scope') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('shared_reservation_scope')"></i>
                            <input :disabled="!!fieldClass('shared_reservation_scope')" type="checkbox" name="shared_reservation_scope" v-model="resource.shared_reservation_scope" true-value="departure" false-value="" />
                            <span>{{ _('Share only within the same departure') }}</span>
                          </label>
                        </div>
                        <div :class="'checkbox ' + fieldClass('hidden')" v-on:click.stop="enableField('hidden')">
                          <label>
                            <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('hidden') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('hidden')"></i>
                            <input :disabled="!!fieldClass('hidden')" type="checkbox" name="hidden" v-model="resource.hidden" true-value="1" false-value="0" />
                            <span>{{ _('Hide from timeline view') }}</span>
                          </label>
                        </div>
                        <div :class="'checkbox ' + fieldClass('grouped')" v-on:click.stop="enableField('grouped')">
                          <label>
                            <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('grouped') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('grouped')"></i>
                            <input :disabled="!!fieldClass('grouped')" type="checkbox" name="grouped" v-model="resource.grouped" true-value="1" false-value="0" />
                            <span>{{ _('Group reservations in timeline view') }}</span>
                          </label>
                        </div>
                        <div  :class="'checkbox ' + fieldClass('enable_calendar')" v-if="settings && settings.calendarauthcode && settings.calendarrefreshtoken" v-on:click.stop="enableField('enable_calendar')">
                          <label>
                            <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('enable_calendar') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('enable_calendar')"></i>
                            <input :disabled="!!fieldClass('enable_calendar')" type="checkbox" name="enable_calendar" v-model="resource.enable_calendar" true-value="1" false-value="0" />
                            <span>{{ _('Synchronize reservations to Google Calendar') }}</span>
                          </label>
                        </div>
                        <div :class="'checkbox ' + fieldClass('skiptickets')" v-on:click.stop="enableField('skiptickets')">
                          <label>
                            <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('skiptickets') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('skiptickets')"></i>
                            <input :disabled="!!fieldClass('skiptickets')" type="checkbox" name="skiptickets" v-model="resource.skiptickets" true-value="1" false-value="0" />
                            <span>{{ _('Do not create tickets for this resource') }}</span>
                          </label>
                        </div>
                        <div :class="'checkbox ' + fieldClass('display_name_in_workflow')" v-if="isFeatureEnabled('delivery2.0')" v-on:click.stop="enableField('display_name_in_workflow')">
                          <label>
                            <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('display_name_in_workflow') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('display_name_in_workflow')"></i>
                            <input :disabled="!!fieldClass('display_name_in_workflow')" type="checkbox" name="display_name_in_workflow" v-model="resource.display_name_in_workflow" true-value="1" false-value="0" />
                            <span>{{ _('Display name in workflow') }}</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-6 rightcol">
                        <div class="form-group">
                          <h3>{{ _('RESERVABLE_TIMES_START') }}</h3>
                        </div>
                        <table class="table" v-if="ranges && ranges.length">
                          <tbody class="timerows" id="ranges">
                            <tr v-for="range in ranges" :class="'range' + (makeRangeDesc(range).match(/fa-ban/) ? ' bg-primary' : '') + (range.ext_id ? ' external': '')">
                              <td v-html="makeRangeDesc(range)" v-on:click="editRange(range)"></td>
                            </tr>
                          </tbody>
                        </table>
                        <div v-else>
                          {{ _('No available times have been defined.') }}
                        </div>
                        <button style="margin-top: 15px; min-height: 50px" class="addtimerow btn btn-success" type="button" v-on:click="addRange"><i class="fa fa-fw fa-plus"></i> {{ _('Add range') }}</button>
                        <div class="checkbox" v-if="isEditMode">
                          <label>
                            <input type="checkbox" v-model="replaceRanges" true-value="1" false-value="0" />
                            {{ _('Replace existing range definitions') }}
                          </label>
                        </div>
                        <hr />
                        <div class="form-group">
                          <h3>{{ _('Scheduled messages') }}</h3>
                          <table class="table table-striped" v-if="notifications.length">
                            <thead>
                              <tr>
                                <th>{{ _('Name') }}</th>
                                <th colspan="2">{{ _('Type') }}</th>
                              </tr>
                            </thead>
                            <tbody class="messagerows" id="notifications">
                              <tr v-for="notification in notifications">
                                <td class="notification" v-on:click="editNotification(notification, true)">{{ makeNotificationDesc(notification) }}</td>
                                <td v-on:click="editNotification(notification, true)">{{ makeNotificationType(notification) }} </td>
                                <td style="width: 20px"><a class="deleteNotification pull-right" href="javascript:;" v-on:click="deleteNotification(notification)"><i class="fa fa-fw fa-close"></i></a></td>
                              </tr>
                            </tbody>
                          </table>
                          <div v-else>
                            {{ _('No notifications have been defined.') }}
                          </div>
                          <button style="margin-top: 15px; min-height: 50px" type="button" class="addmessage btn btn-success" v-on:click="addNotification(true)"><i class="fa fa-fw fa-plus"></i> {{ _('Add message') }}</button>
                        </div>
                        <div class="checkbox" v-if="isEditMode">
                          <label>
                            <input type="checkbox" v-model="replaceNotifications" true-value="1" false-value="0" />
                            {{ _('Replace existing notifications') }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              <transition v-on="slideTransition">
                <div id="collapseAttrs" class="panel-collapse" role="tabpanel" aria-labelledby="headingAttrs" v-if="isPanelOpen('attrs') && selectedType === 'buyable'">
                  <div class="panel-body">
                    <div class="row">
                      <div class="col-sm-6 leftcol">
                        <div :class="'form-group ' + fieldClass('capacity')" v-on:click.stop="enableField('capacity')">
                          <label for="capacity">{{ _('Stock balance') }}</label>
                          <i v-if="isEditMode" :class="'fa fa-fw pull-right ' + (fieldClass('capacity') ? 'fa-unlock' : 'fa-lock')" v-on:click.stop="toggleField('capacity')"></i>
                          <div class="row">
                            <div class="col-md-9">
                              <input :disabled="!!fieldClass('capacity')" id="capacity" class="form-control" ref="capacity" type="number" data-android-inputmode="decimal" v-model="resource.capacity" />
                            </div>
                            <div class="col-md-3">
                              <select :disabled="!!fieldClass('capacity')" class="form-control" ref="unit" v-model="resource.unit">
                                <option value="pcs">{{ _('pcs') }}</option>
                                <option value="m3">m&#179;</option>
                                <option value="l">l</option>
                                <option value="dl">dl</option>
                                <option value="cl">cl</option>
                                <option value="ml">ml</option>
                                <option value="kg">kg</option>
                                <option value="g">g</option>
                                <option value="km">km</option>
                                <option value="m">m</option>
                                <option value="m2">m&#178;</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="!isEditMode && isFeatureEnabled('packaging')">
        <div class="col-xs-12 template-container">
          <div class="form-group" v-if="!forceType && selectedType !== 'openinghours'">
            <label for="selectedResourcepool">{{ _('Create in resource pool') }}</label>
            <select class="form-control" id="selectedResourcepool" v-model="selectedResourcepool">
              <option :value="null">{{ _('No, create at top level') }}</option>
              <option value="new">{{ _('Create inside a new resource pool') }}</option>
              <optgroup :label="_('Active resource pools')" v-if="selectableOpenResourcepools && selectableOpenResourcepools.length">
                <option v-for="pool in selectableOpenResourcepools" :value="pool.id">{{ pool.name }}</option>
              </optgroup>
              <optgroup :label="_('All resource pools')">
                <option v-for="pool in resourcepoolOptions" :value="pool.id">{{ pool.name }}</option>
              </optgroup>
            </select>
          </div>
          <div class="form-group" v-if="!forceType && selectedType !== 'openinghours' && selectedResourcepool === 'new'">
            <label for="newResourcepoolName">{{ _('Name') }}</label>
            <input class="form-control" type="text" id="newResourcepoolName" v-model="newResourcepoolName" :placeholder="_('Enter a name for the resource pool')" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selected" :disabled="!canSubmit"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import modals from '~/lib/modals'
import notifications from '~/lib/notifications'
import rangehelpers from '~/lib/rangehelpers'
import settingshelpers from '~/lib/settingshelpers'
import slidetransition from '~/lib/slidetransition'

export default {
  props: ['openResourcepools', 'forceType', 'context', 'selectedResources'],
  mixins: [modals, notifications, rangehelpers, settingshelpers, slidetransition],
  data () {
    return {
      selectedType: null,
      selectedResourcepool: null,
      newResourcepoolName: '',
      allResourcepools: [],
      count: 1,
      naming: 'addnum',
      namingStart: 1,
      nameList: null,
      notifications: [],
      ranges: [],
      enabledFields: {},
      resource: {},
      mouseListener: null,
      replaceRanges: 0,
      replaceNotifications: 0
    }
  },
  computed: {
    ...mapGetters(['allSettings', 'shopId', 'baseDomain', 'locale', 'version', 'dateFormat', 'timeFormat', 'apiKey']),
    settings () {
      return this.shopSettings(this.shopId)
    },
    isEditMode () {
      return !!this.selectedResources
    },
    newResourcePlaceholder () {
      if (!this.selectedType) {
        return this._('Enter a name for the resource or resource pool')
      }
      if (this.selectedType === 'resourcepool') {
        return this._('Enter a name for the resource pool')
      }
      return this._('Enter a name for the resource')
    },
    canSubmit () {
      if (this.selectedResourcepool == 'new' && !this.newResourcepoolName) {
        return false
      }
      return this.isEditMode || this.selectedType && this.resource.name
    },
    selectableOpenResourcepools () {
      if (this.selectedType === 'resourcepool') {
        return this.openResourcepools.filter(rp => rp.level === 0)
      }
      return this.openResourcepools
    },
    resourcepoolOptions () {
      if (this.selectedType === 'resourcepool') {
        return this.allResourcepools.filter(rp => Number(rp.level) === 0).map(rp => { return { id: rp.id, name: rp.name }; }).sort((a, b) => a.name > b.name ? 1 : -1)  
      }
      return this.allResourcepools.map(rp => { return { id: rp.id, name: rp.name }; }).sort((a, b) => a.name > b.name ? 1 : -1)
    },
    showResources () {
      if (!this.forceType || this.forceType === 'resource') {
        return true
      }
      return false
    },
    showResourcepool () {
      if (!this.forceType || this.forceType === 'resourcepool') {
        return true
      }
      return false
    }
  },
  methods: {
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    hideModal () {
      this.$emit('close')
    },
    fieldClass (field) {
      return !this.isEditMode || this.enabledFields[field] ? '' : 'disabled'
    },
    toggleField (field) {
      this.enabledFields[field] = !this.enabledFields[field]
    },
    enableField (field) {
      if (this.enabledFields.hasOwnProperty(field)) {
        return
      }
      this.enabledFields[field] = true
      if (this.$refs.hasOwnProperty(field)) {
        nextTick(() => {
          this.$refs[field].focus()
        })
      }
    },
    btnClass (button) {
      let s = 'btn '
      if (button === 'buyable') {
        s += 'btn-success newProduct newResource newBuyableResource'
      } else if (button === 'openinghours') {
        s += 'btn-default newProduct newResource newOpeningHours'
      } else if (button === 'resourcepool') {
        s += 'btn-default newProduct newResource newCategory newResourcepool'
      } else {
        s += 'btn-success newProduct newResource'
      }
      if (this.selectedType === button) {
        s += ' selectedType'
      }
      if (this.selectedType && this.selectedType != button) {
        return 'hidden'
      }
      return s
    },
    selectType (type) {
      if(type != this.selectedType) {
        this.selectedType = type
        this.focusName()
      } else {
        this.selectedType = false
      }
    },
    selected () {
      const data = {
        selectedType: this.selectedType,
        selectedResourcepool: this.selectedResourcepool,
        newResourcepoolName: this.newResourcepoolName
      }
      if (!this.isEditMode || this.enabledFields.hasOwnProperty('name')) {
        data.name = this.resource.name
      }
      let count = parseInt(this.count, 10)
      if (count > 1) {
        let resourceData = {}
        if (this.isEditMode) {
          Object.keys(this.resource).forEach(key => {
            if (this.enabledFields.hasOwnProperty(key)) {
              resourceData[key] = this.resource[key]
            }
          })
          if (this.enabledFields.hasOwnProperty('capacity') && this.resource.unit) {
            resourceData.unit = this.resource.unit
          }
        } else {
          resourceData = { ...this.resource }
        }
        if (this.notifications && this.notifications.length) {
          resourceData.sharedNotification = this.notifications
        }
        if (this.ranges && this.ranges.length) {
          resourceData.ownRange = this.ranges
        }
        if (this.version) {
          resourceData.version = this.version
        }
        data.multiply = {
          count: count, 
          naming: this.naming, 
          namingStart: this.namingStart,
          nameList: this.nameList,
          resource: resourceData
        }
        if (this.isEditMode) {
          data.multiply.replaceRanges = this.replaceRanges
          data.multiply.replaceNotifications = this.replaceNotifications
        }
      }
      this.$emit('selected', data)
    },
    selectNone () {
      this.selectedType = null
    },
    focusName () {
      nextTick(() => {
        if (this.$refs.name) {
          this.$refs.name.focus()
        }
      })
    },
    async loadResourcepools () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/resourcepools.json?apikey=' + this.apiKey)
      } catch(e) {}
      if (response) {
        this.allResourcepools = response.data
      }
    }
  },
  watch: {
    naming (newValue) {
      if (!newValue) {
        return
      }
      if (newValue.match(/char/) && parseInt(this.namingStart)) {
        this.namingStart = 'A'
      } else if (newValue.match(/num/) && !parseInt(this.namingStart)) {
        this.namingStart = 1
      }
    },
    selectedType (newValue) {
      if (newValue === 'openinghours') {
        this.count = 1
      }
      if (newValue === 'resourcepool' && this.selectedResourcepool) {
        const exists = this.resourcepoolOptions.find(rp => rp.id === this.selectedResourcepool)
        if (!exists) {
          this.selectedResourcepool = null
        }
      }
    }
  },
  mounted () {
    if (this.selectedResources && this.selectedResources.length) {
      this.count = this.selectedResources.length
      this.selectedType = this.selectedResources[0].displayedtype
      this.naming = 'none'
    }
    this.loadResourcepools()
    if (this.openResourcepools && this.openResourcepools.length === 1 && this.isFeatureEnabled('packaging')) {
      this.selectedResourcepool = this.openResourcepools[0].id
    }
    if (this.$refs.name) {
      this.$refs.name.focus()
    }
    if (this.forceType === 'resourcepool') {
      this.selectedType = 'resourcepool'
    }
  }
}
</script>

<style scoped>
.disabled.form-group label {
  opacity: 0.5;
}
.checkbox label {
  width: 100%;
}
.disabled.checkbox label span {
  opacity: 0.5;
}
.disabled.form-group:hover, .disabled.form-group>label:hover, .disabled.form-group input[disabled]:hover, 
.disabled.checkbox>label:hover, .disabled.checkbox input[disabled]:hover, .disabled.form-group select[disabled]:hover, 
i.pull-right {
  cursor: pointer !important;  
}
label {
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.disabled.form-group input[disabled], .disabled.form-group select[disabled], .disabled.form-group label {
  pointer-events: none;
}
.panel-collapse {
  overflow-y: hidden;
}
</style>